import { getListBrowserStore } from '@ts-private/list-browser';

export const contentTypeStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'code',
      caption: 'ContentTypes.Code',
      type: 'text'
    },
    {
      name: 'name',
      caption: 'ContentTypes.Name',
      type: 'text'
    },
    {
      name: 'isFileType',
      caption: 'ContentTypes.IsFile',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'ContentTypes.Code',
      value: 'Code'
    },
    {
      caption: 'ContentTypes.Name',
      value: 'Name'
    }
  ],
  pager: {
    orderBy: 'Name',
    direction: 'asc'
  }
});
